import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/types';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { RsvpBlockGrabber } from './components/RsvpBlockGrabber';
import { RSVP_BLOCK_SCHEMA_URL, RSVP_BLOCK_COMPONENT_TYPE } from './RsvpBlock.constants';

// Lazy load view components
const RsvpBlockAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorRsvpBlockAdd" */ './components/RsvpBlockAdd'), 'RsvpBlockAdd');

const RsvpBlockEdit = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorRsvpBlockEdit" */ './components/RsvpBlockEdit'), 'RsvpBlockEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const RsvpBlockConfig: AdminJsonComponentConfig = {
  schemaUrl: RSVP_BLOCK_SCHEMA_URL,
  componentType: RSVP_BLOCK_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: RsvpBlockAdd,
    dragComponentView: RsvpBlockGrabber,
    editComponentView: RsvpBlockEdit,
    createComponentView: RsvpBlockEdit,
  },
} as const;
